export default __webpack_public_path__ + "static/media/GA_Zoom-2.c5ca9c2a.wav";